import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { ISignedDocumentResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";

export const selectorIsRequirementReadyToSignAsPayee = (
  requirement: IRequirementResponse,
  document?: ISignedDocumentResponse
): boolean => {
  const isSignedByPayee = document?.events?.payeeSignedAt;

  return (
    !!document &&
    requirement.dataSourceStatus !== RequirementStatus.Complete &&
    !isSignedByPayee
  );
};
